export default __webpack_public_path__ + "static/media/perkyjerky_header.df3aa083.jpg";